module.exports = ".icon-title {\n  color: 'grey';\n  margin: 20px; }\n\n#noResults {\n  margin: auto;\n  text-align: center;\n  color: grey;\n  margin-top: 30px;\n  margin-bottom: 30px; }\n\n.mat-column-name {\n  min-width: 40%; }\n\n.mat-column-actions {\n  min-width: 20%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form-views/components/data/form-view-data-list/form-view-data-list.component.scss
// module id = ./src/app/form-views/components/data/form-view-data-list/form-view-data-list.component.scss
// module chunks = main